/// Mesmo limite do backend (CreateBoardColumnValidator.MaxNameLength).
export const STAGE_NAME_MAX_LENGTH = 40;
